const statuses = [
    {
        name: 'Unstarted',
        value: 'unstarted',
    },
    {
        name: 'Attended',
        value: 'attended',
    },
    {
        name: 'Invoiced',
        value: 'invoiced',
    },
];

export {statuses}


// WEBPACK FOOTER //
// ./resources/assets/js/include/Job.js